import React from "react";
import Moment from "react-moment";
import { Link, NavLink } from "react-router-dom";
import { FORMAT_DATE_MOMENT, TYPE_TESTS } from "../../../../api/constant";
import Select from "react-select";

import LineTitle from "../../../app/atoms/LineTitle";
import Toggle from "react-toggle";
import { customStyles } from "../../../../utilities/select-styles.utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBox, faCaretDown, faFilePen } from "@fortawesome/free-solid-svg-icons";
import {
  useActionsTests,
  useTests,
  useDispatchTestIndex,
} from "../../../../context/inventory/TestIndexProvider";
import { types } from "../../../../reducers/inventory/testsReducer";
const TestIndex = () => {
  const dispatch = useDispatchTestIndex();
  const state=useTests();
  const {
    tests: { elements: listTests },
    filter:{headquarter_id},
    headquarters: { elements: listHeadquarters },
    tests_id_deploy,
  } = state;
  const actions = useActionsTests();
  const getTypeName = (type) => {
    const filter = TYPE_TESTS.filter((t) => t.code === type);
    return filter.length > 0 ? filter[0].name : null;
  };
  return (
    <div className="container">
      <LineTitle title={"Lista de pruebas"} />
      <br />
      <div className="flex justify-betwen">
        <div className="form-group">
          <label className="control-label">Sede</label>
          <Select
            value={listHeadquarters.filter((w) => w.id === headquarter_id)} 
            placeholder="Sede"
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            options={listHeadquarters}
            styles={customStyles}
            isClearable
            onChange={(e) =>
              dispatch({
                type: types.CHANGE_FILTER_TESTS,
                payload: {...state.filter,headquarter_id:e ? e.id : null  }
              })
            }
          />
        </div>
        <div>
          {" "}
          <NavLink to={"/inventory/test"}>
            <div className="btn-default ">
              <FontAwesomeIcon icon={faFilePen} />
              &nbsp;
              <span>Nueva</span>
            </div>
          </NavLink>
        </div>
      </div>
      <br />
      <table className="table table-default-app">
        <thead className="thead-dark">
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Ref</th>
            <th scope="col">Fecha creación</th>
            <th scope="col">Nombre de prueba</th>
            <th scope="col">Versiónes</th>
            <th scope="col">Tipo</th>
            <th scope="col">Descripción</th>
            <th scope="col">Observ.</th>
            <th scope="col">Archivos</th>

            <th scope="col">Ultima modificación </th>
            <th scope="col">Estado</th>
          </tr>
        </thead>
        <tbody>
          {listTests.map((test) => {
            return (
              <>
                <tr key={test.id}>
                  <td>
                    {test.versions.length > 0 && (
                      <FontAwesomeIcon
                        onClick={() =>
                          dispatch({
                            type: types.TOGGLE_TEST_LIST,
                            payload: test.id,
                          })
                        }
                        className="blue cursor-pointer"
                        icon={faCaretDown}
                      />
                    )}
                  </td>
                  <td>
                    {" "}
                    <Link to={`/inventory/test/${test.id}`}>
                      {test.reference}
                    </Link>{" "}
                  </td>
                  <td>
                    {" "}
                    <Moment format={FORMAT_DATE_MOMENT}>
                      {test.created_at}
                    </Moment>
                  </td>
                  <td>{test.name}</td>
                  <td>{test.versions_count}</td>
                  <td> {getTypeName(test.type)}</td>
                  <td>{test.description}</td>
                  <td></td>
                  <td></td>

                  <td>
                    <Moment
                      date={test.updated_at}
                      format={FORMAT_DATE_MOMENT}
                    />{" "}
                  </td>
                  <td>
                    {" "}
                    <Toggle
                      onClick={() =>
                        actions.updateFieldTest(test.id, {
                          is_active: !test.is_active,
                        })
                      }
                      icons={false}
                      checked={test.is_active}
                    />{" "}
                    &nbsp; {test.is_active ? "Activa" : "Inactiva"}
                  </td>
                </tr>
                {tests_id_deploy.includes(test.id) &&
                  test.versions.map((v, index) => {
                    return (
                      <tr key={v.id}>
                        <td> {v.id} </td>
                        <td>
                          {test.reference} - {v.version}{" "}
                        </td>

                        <td>
                          <Moment
                            date={v.created_at}
                            format={FORMAT_DATE_MOMENT}
                          />
                        </td>
                        <td> {v.name} </td>
                        <td></td>
                        <td> {getTypeName(v.type)}</td>
                        <td>{v.description}</td>
                        <td>{v.notes_count}</td>
                        <td>{v.documents_count}</td>

                        <td>
                          {" "}
                          <Moment
                            date={v.updated_at}
                            format={FORMAT_DATE_MOMENT}
                          />{" "}
                        </td>
                        <td>
                          {" "}
                          <Toggle
                            onClick={() =>
                              actions.updateFieldTest(v.id, {
                                is_active: !v.is_active,
                              })
                            }
                            icons={false}
                            checked={v.is_active}
                          />{" "}
                          &nbsp; {v.is_active ? "Activa" : "Inactiva"}
                        </td>
                      </tr>
                    );
                  })}
              </>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default TestIndex;
